var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagCircleRed = function SvgTagCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      fill: "#eaeaea"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#061e21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.208 11.99a1.719 1.719 0 1 1-3.437 0 1.719 1.719 0 0 1 3.437 0m-1.145 0a.573.573 0 1 0-1.146 0 .573.573 0 0 0 1.146 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.98h5.255c.304 0 .595.12.81.335l8.02 8.02a1.145 1.145 0 0 1 0 1.62l-5.254 5.256a1.146 1.146 0 0 1-1.62 0L8.815 15.19a1.15 1.15 0 0 1-.336-.81V9.125a1.146 1.146 0 0 1 1.146-1.146m0 6.4 8.02 8.02 5.256-5.254-8.021-8.021H9.625z"
  }))));
};
export default SvgTagCircleRed;